/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * UserExportApi - axios parameter creator
 * @export
 */
export const UserExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Downloads all users in the current organization as a CSV file.
         * @summary Export users as CSV
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsersCsv: async (orgId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserExportApi - functional programming interface
 * @export
 */
export const UserExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserExportApiAxiosParamCreator(configuration)
    return {
        /**
         * Downloads all users in the current organization as a CSV file.
         * @summary Export users as CSV
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUsersCsv(orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUsersCsv(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserExportApi - factory interface
 * @export
 */
export const UserExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserExportApiFp(configuration)
    return {
        /**
         * Downloads all users in the current organization as a CSV file.
         * @summary Export users as CSV
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsersCsv(orgId?: number, options?: any): AxiosPromise<string> {
            return localVarFp.exportUsersCsv(orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserExportApi - object-oriented interface
 * @export
 * @class UserExportApi
 * @extends {BaseAPI}
 */
export class UserExportApi extends BaseAPI {
    /**
     * Downloads all users in the current organization as a CSV file.
     * @summary Export users as CSV
     * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserExportApi
     */
    public exportUsersCsv(orgId?: number, options?: any) {
        return UserExportApiFp(this.configuration).exportUsersCsv(orgId, options).then((request) => request(this.axios, this.basePath));
    }
}
